import { render, staticRenderFns } from "./CompanyNotice.vue?vue&type=template&id=166d2652&scoped=true&lang=pug&"
import script from "./scripts/CompanyNotice.js?vue&type=script&lang=js&"
export * from "./scripts/CompanyNotice.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166d2652",
  null
  
)

export default component.exports